/**
 * Configuration Firebase Web SDK.
 *
 * Les valeurs sont lues depuis les variables d'environnement Vite
 * (`VITE_FIREBASE_*`). Elles sont publiques (exposées côté client de toute
 * façon) mais on les externalise du source pour pouvoir changer de projet
 * Firebase sans toucher au code.
 *
 * Si une seule valeur est manquante, `isConfigured()` retourne `false` et
 * les modules en aval (auth) basculent en mode dégradé (UI affiche
 * "Configuration manquante" au lieu de crasher).
 */

export type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
};

export const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
};

/** Toutes les clés requises sont-elles présentes ? */
export function isConfigured(): boolean {
  return (
    firebaseConfig.apiKey !== '' &&
    firebaseConfig.authDomain !== '' &&
    firebaseConfig.projectId !== '' &&
    firebaseConfig.appId !== ''
  );
}
